var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3",
    transform: "matrix(1 0 0 .8 0 27.184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "86.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "41.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "18.52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "-3.98"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "63.52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -.8 0 100.82 106.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "86.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "41.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "18.52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "-3.98"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "63.52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1.25 -.8 0 100.82 -33.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "86.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "41.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "18.52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "-3.98"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "63.52"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.002 37.05h5.446v3.938h-2.751v3.414h2.391v3.85h-2.391v3.377h2.775v3.964H44.01zm9.892 5.764M53.894 42.814v1.575q1.104-2.013 2.24-2.013 1.367 0 1.767 2.213.624-1.15 1.152-1.675.544-.525 1.263-.525 1.8 0 1.8 3.938v9.278h-2.583v-7.54q0-1.85-.768-1.85-.784 0-.784 1.825v7.565h-2.583V47.84q0-.712-.216-1.163-.208-.462-.536-.462-.344 0-.56.45-.208.45-.208 1.213v7.74h-2.575v-12.78zM64.043 36.024h2.575v8.328h.048q.472-1.013.88-1.488.416-.475 1.064-.475 1.087 0 1.815 1.775.728 1.763.728 5.064 0 3.051-.704 4.914-.696 1.863-1.8 1.863-1.15 0-1.983-2.088h-.048v1.65h-2.575zm4.55 13.117q0-3.176-1.039-3.176-.936 0-.936 3.063 0 1.763.24 2.589.248.8.784.8.952 0 .952-3.276zM76.511 51.692h2.175q-.623 4.3-3.11 4.3-1.552 0-2.464-1.85-.903-1.85-.903-5.101 0-3.026.903-4.852.904-1.838 2.407-1.838.904 0 1.744.888.832.875 1.215 2.338.384 1.463.424 4.602h-4.31q.056 2.85 1.015 2.85.328 0 .584-.375t.312-.975zm-1.871-3.69h1.871q-.024-1.35-.24-1.987-.216-.65-.672-.65-.511 0-.735.625t-.224 2.013zM84.493 36.024h2.567v19.569h-2.583v-1.676h-.032Q83.58 56.03 82.5 56.03q-1.135 0-1.84-1.863-.695-1.863-.695-4.976 0-3.101.712-4.94.712-1.85 1.871-1.85 1.056 0 1.944 1.9zm0 13.08q0-3.152-.976-3.152-1.008 0-1.008 3.351 0 1.488.264 2.301.272.8.752.8.448 0 .704-.863.256-.862.256-2.438zM93.09 36.024h2.567v19.569h-2.583v-1.676h-.032q-.864 2.113-1.944 2.113-1.135 0-1.839-1.863-.696-1.863-.696-4.976 0-3.101.712-4.94t1.871-1.85q1.056 0 1.944 1.9zm0 13.08q0-3.152-.976-3.152-1.008 0-1.008 3.351 0 1.488.264 2.301.272.8.752.8.448 0 .704-.863t.256-2.438zM101.455 51.692h2.175q-.623 4.3-3.11 4.3-1.552 0-2.464-1.85-.904-1.85-.904-5.101 0-3.026.904-4.852.904-1.838 2.407-1.838.904 0 1.744.888.832.875 1.215 2.338.384 1.463.424 4.602h-4.31q.056 2.85 1.015 2.85.328 0 .584-.375t.312-.975zm-1.871-3.69h1.871q-.024-1.35-.24-1.987-.216-.65-.672-.65-.512 0-.735.625t-.224 2.013zM109.436 36.024h2.568v19.569h-2.584v-1.676h-.032q-.863 2.113-1.943 2.113-1.136 0-1.84-1.863-.695-1.863-.695-4.976 0-3.101.712-4.94t1.871-1.85q1.056 0 1.943 1.9zm0 13.08q0-3.152-.975-3.152-1.008 0-1.008 3.351 0 1.488.264 2.301.272.8.752.8.448 0 .704-.863.255-.862.255-2.438z"
  })), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "86.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "41.02"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "18.52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "-3.98"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "10",
    width: "16",
    ry: "2",
    y: "63.52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "126",
    width: "100",
    fill: "#000",
    ry: "3.75",
    x: "14",
    y: "-17.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3 61.15c-4.2 9.25-12.2 15.5-21.3 15.5-13.5 0-24.5-13.75-24.5-30.62s11-30.62 24.5-30.62c9.1 0 17.1 6.25 21.3 15.63l13-9.37c-6.8-14.87-19.6-25-34.3-25-21.8 0-39.5 22.13-39.5 49.38S42.2 95.43 64 95.43c14.6 0 27.4-10 34.2-24.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "23",
    cy: "-5.23",
    fill: "#fff",
    rx: "3",
    ry: "3.75"
  })));
};